import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  Client,
  PaginatedProjectList,
  PaginatedProjectWithWorkOrderCountsList,
  Project,
  ProjectDetailed,
} from "../../app/generated-axios-client";

export type ProjectTicketDateEditPayload = {
  projectId: string;
  ticketId: string;
  field: "start" | "deadline";
  value: string | null;
};

export type ProjectTicketAssigneesEditPayload = {
  projectId: string;
  ticketId: string;
  assigneeIds: number[];
};

export interface ProjectState {
  project: ProjectDetailed | null;
  list: PaginatedProjectList | PaginatedProjectWithWorkOrderCountsList;
  clients: Client[];
  clientProjects: Project[];
}

const initialState: ProjectState = {
  project: null,
  list: {
    pagination: {
      total_items: 0,
      total_pages: 0,
      current_page: 0,
      per_page: 0,
    },
    results: [],
  },
  clients: [],
  clientProjects: [],
};

export const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    addOrUpdateProject: (_state, _action: PayloadAction<Project>) => {},
    markProjectDelayed: (_state, _action: PayloadAction<string>) => {},
    projectTicketDateEdit: (
      _state,
      _action: PayloadAction<ProjectTicketDateEditPayload>
    ) => {},
    projectTicketAssigneesEdit: (
      _state,
      _action: PayloadAction<ProjectTicketAssigneesEditPayload>
    ) => {},
    projectTicketDelete: (
      _state,
      _action: PayloadAction<{ projectId: string; ticketId: string }>
    ) => {},
    resumeProject: (_state, _action: PayloadAction<string>) => {},
    storeProject: (state, action: PayloadAction<ProjectDetailed>) => {
      state.project = action.payload;
    },
    removeProject: (state) => {
      state.project = null;
    },
    deleteProject: (_state, _action: PayloadAction<string>) => {},
    addProjectList: (state, action: PayloadAction<ProjectState["list"]>) => {
      state.list = action.payload;
    },
    addClients: (state, action: PayloadAction<Client[]>) => {
      state.clients = action.payload;
    },
    storeClientProjects: (state, action: PayloadAction<Project[]>) => {
      state.clientProjects = action.payload;
    },
  },
});

export const projectActions = projectSlice.actions;
export default projectSlice.reducer;
